export const MATRIX_TAB = {
  POPULATIONS: 'populations',
  DEFINITION: 'definition',
  AWARD_CALCULATION: 'award-calculation',
} as const satisfies Record<string, string>;

export type MatrixTabValue = (typeof MATRIX_TAB)[keyof typeof MATRIX_TAB];

export const MATRIX_TABS: Array<{ value: MatrixTabValue; label: string }> = [
  { value: MATRIX_TAB.POPULATIONS, label: '1. Populations' },
  { value: MATRIX_TAB.DEFINITION, label: '2. Definition' },
  { value: MATRIX_TAB.AWARD_CALCULATION, label: '3. Award calculation' },
];

export const BASELINE_POPULATIONS = [
  { value: 'COMMUTER', label: 'Commuter' },
  { value: 'IN_STATE', label: 'In-State' },
  { value: 'OUT_OF_STATE', label: 'Out-of-State' },
];

export const POPULATION_TYPES = {
  BASELINE: 'baseline',
  CUSTOM: 'custom',
} as const;

export type PopulationType =
  (typeof POPULATION_TYPES)[keyof typeof POPULATION_TYPES];
